<!-- 地方平台详情页 -->
<template>
    <div class="local-detail">
        <div
            class="banner"
            :style="{
                'background-image': bannerData.bannerUrl
                    ? `url(${bannerData.bannerUrl})`
                    : `url(${defaultBannerImage})`,
            }"
        >
            <div class="banner-content">
                <h1>{{ areaName }} 一站式算力交易和服务平台</h1>
                <p>
                    实现对通用算力、超算算力、人工智能算力的统一管理、统一服务和统一运营
                </p>
<!--                <div-->
<!--                    class="banner-more"-->
<!--                    @click="handleToBannerMore"-->
<!--                    v-if="bannerData.linkUrl"-->
<!--                >-->
<!--                    了解更多-->
<!--                </div>-->
            </div>
        </div>

        <div class="container">
            <div class="core-resources" v-show="resources.length != 0">
                <div class="section-title">核心资源</div>
                <div class="section-title-en">Core Resources</div>
                <el-row :gutter="20" class="custom-row">
                    <el-col
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        v-for="(item, index) in resources"
                        :key="index"
                    >
                        <div class="resource-card">
                            <div class="resource-image">
                                <img :src="item.photoUrl" :alt="item.title" />
                            </div>
                            <div class="resource-content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.info }}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="special-services" v-show="resources.length != 0">
                <div class="section-title">特色服务</div>
                <div class="section-title-en">Unique Services</div>
                <el-row :gutter="20" class="custom-row">
                    <el-col
                        :xs="24"
                        :sm="12"
                        :md="6"
                        :lg="6"
                        v-for="(service, index) in specialServices"
                        :key="index"
                    >
                        <div class="service-card">
                            <div class="service-image">
                                <img
                                    :src="service.photoUrl"
                                    :alt="service.title"
                                />
                            </div>
                            <div class="service-content">
                                <h3>{{ service.title }}</h3>
                                <p>{{ service.info }}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="policy-support" v-show="resources.length != 0">
                <div class="section-title">政策支持</div>
                <div class="section-title-en">Policy Support</div>
                <el-row :gutter="20">
                    <el-col
                        :xs="24"
                        :sm="24"
                        :md="24"
                        :lg="24"
                        v-for="(policy, index) in policies"
                        :key="index"
                    >
                        <div class="policy-card">
                            <div class="policy-image">
                                <img
                                    :src="policy.photoUrl"
                                    :alt="policy.title"
                                />
                            </div>
                            <div class="policy-content">
                                <h3>{{ policy.title }}</h3>
                                <p>{{ policy.info }}</p>
                                <el-button
                                    type="primary"
                                    class="detail-btn"
                                    @click="handleToPolicyDetail(policy)"
                                    >查看详情</el-button
                                >
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

<!--            <div class="application-cases" v-show="resources.length != 0">-->
<!--                <div class="section-title">应用案例</div>-->
<!--                <div class="section-title-en">Application Cases</div>-->
<!--                <el-row :gutter="20">-->
<!--                    <el-col-->
<!--                        :xs="24"-->
<!--                        :sm="12"-->
<!--                        :md="8"-->
<!--                        :lg="8"-->
<!--                        v-for="(case_item, index) in applicationCases"-->
<!--                        :key="index"-->
<!--                    >-->
<!--                        <div class="case-card">-->
<!--                            <div class="case-image">-->
<!--                                <img-->
<!--                                    :src="case_item.photoUrl"-->
<!--                                    :alt="case_item.title"-->
<!--                                />-->
<!--                            </div>-->
<!--                            <div class="case-content">-->
<!--                                <h3>{{ case_item.title }}</h3>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </el-col>-->
<!--                </el-row>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
import {
    areaPlatformList, //banner列表
    areaCoreResourceList, //核心资源
    areaFeaturedServiceList, //特色服务
    areaPolicySupportList, //政策支持
    areaApplicationCaseList, //应用案例
} from "@/api/admin";
export default {
    name: "LocalDetail",
    data() {
        return {
            areaType: "", // 区域类型
            areaName: "", // 区域名称
            areaOptions: [
                {
                    value: 1,
                    label: "江苏",
                },
                {
                    value: 2,
                    label: "上海",
                },
                {
                    value: 3,
                    label: "安徽",
                },
                {
                    value: 4,
                    label: "浙江",
                },
            ],
            bannerData: {
                bannerUrl: "",
                linkUrl: "",
            },
            defaultBannerImage: require("../../assets/bg/diqvzhuyebanner.png"), // 默认图片路径
            resources: [],
            specialServices: [],
            applicationCases: [],
            policies: [],
        };
    },
    created() {
        this.areaType = this.$route.query.areaType;
        this.areaName =
            this.areaOptions.find((item) => item.value == this.areaType)
                ?.label || this.areaType;
        // 调用接口获取数据
        this.getBannerList();
        this.getResourcesList();
        this.getServicesList();
        this.getPoliciesList();
        this.getCasesList();
    },
    methods: {
        // 获取banner列表
        async getBannerList() {
            try {
                let params = {
                    areaType: this.areaType,
                };
                const res = await areaPlatformList(params);
                if (res.code === 200) {
                    if (res.data.records.length > 0) {
                        this.bannerData = res.data.records[0];
                    } else {
                        this.bannerData = {
                            bannerUrl: "",
                            linkUrl: "",
                        };
                    }
                }
            } catch (error) {
                console.error("获取banner列表失败:", error);
            }
        },
        // 获取核心资源列表
        async getResourcesList() {
            try {
                let params = {
                    areaType: this.areaType,
                };
                const res = await areaCoreResourceList(params);
                if (res.code === 200) {
                    this.resources = res.data.records;
                }
            } catch (error) {
                console.error("获取核心资源列表失败:", error);
            }
        },
        // 获取特色服务列表
        async getServicesList() {
            try {
                let params = {
                    areaType: this.areaType,
                };
                const res = await areaFeaturedServiceList(params);
                if (res.code === 200) {
                    this.specialServices = res.data.records;
                }
            } catch (error) {
                console.error("获取特色服务列表失败:", error);
            }
        },
        // 获取政策支持列表
        async getPoliciesList() {
            try {
                let params = {
                    areaType: this.areaType,
                };
                const res = await areaPolicySupportList(params);
                if (res.code === 200) {
                    this.policies = res.data.records;
                }
            } catch (error) {
                console.error("获取政策支持列表失败:", error);
            }
        },
        // 获取应用案例列表
        async getCasesList() {
            try {
                let params = {
                    areaType: this.areaType,
                };
                const res = await areaApplicationCaseList(params);
                if (res.code === 200) {
                    this.applicationCases = res.data.records;
                }
            } catch (error) {
                console.error("获取应用案例列表失败:", error);
            }
        },
        // 跳转至更多详情
        handleToBannerMore() {
            window.open(this.bannerData.linkUrl, "_blank");
        },
        // 跳转至政策详情
        handleToPolicyDetail(policy) {
            if (policy.linkUrl) {
                window.open(policy.linkUrl, "_blank");
            } else {
                this.$message.warning("暂无详情");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.local-detail {
    .section-title {
        text-align: center;
        font-size: 36px;
        color: #333333;
    }

    .section-title-en {
        text-align: center;
        font-size: 20px;
        color: #cdcdcd;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .banner {
        height: 220px;
        /* background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); */
        color: white;
        display: flex;
        align-items: center;
        background-image: url("../../assets/bg/diqvzhuyebanner.png");
        /* background-size: cover; */
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;

        .banner-content {
            padding: 0 241px;
            position: relative;
            width: 100%;

            .banner-more {
                position: absolute;
                right: 241px;
                top: 50%;
                transform: translateY(-50%);
                color: #fff;
                cursor: pointer;
                font-size: 14px;
                width: 140px;
                height: 50px;
                border-radius: 25px 25px 25px 25px;
                border: 2px solid #e3e3e3;
                text-align: center;
                line-height: 50px;
            }

            h1 {
                font-size: 48px;
                margin-bottom: 16px;
            }

            p {
                font-size: 16px;
                opacity: 0.9;
                margin-bottom: 60px;
            }
        }
    }

    .container {
        margin: 0 auto;
        padding: 0px;
    }

    .application-cases {
        padding: 0 241px 67px 241px;

        .case-card {
            background: white;
            border-radius: 8px;
            /* box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); */
            margin-bottom: 20px;
            height: 100%;
            transition: all 0.3s ease;
            border: 1px solid #e3e3e3;

            &:hover {
                /* transform: translateY(-5px); */
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            }

            .case-image {
                height: 228px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .case-content {
                padding: 20px;
                text-align: center;

                h3 {
                    margin: 0;
                    font-size: 16px;
                    color: #333;
                    font-weight: normal;
                }
            }
        }
    }

    .policy-support {
        padding: 67px 241px;
        background-image: url("../../assets/bg/shan.png");
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;

        .policy-card {
            /* background: white; */
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            display: flex;
            overflow: hidden;
            transition: all 0.3s ease;
            padding: 44px;

            &:hover {
                /* transform: translateY(-5px); */
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            }

            .policy-image {
                width: 300px;
                height: 195px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .policy-content {
                flex: 1;
                padding-left: 53px;
                /* padding: 30px; */
                display: flex;
                flex-direction: column;
                /* justify-content: space-between; */

                h3 {
                    margin: 25px 0 15px;
                    font-size: 20px;
                    font-weight: normal;
                    color: #333;
                }

                p {
                    font-size: 14px;
                    color: #858585;
                    margin: 0 0 40px;
                    line-height: 1.6;
                }

                .detail-btn {
                    align-self: flex-start;
                    background: #067bf3;
                    width: 118px;
                    height: 40px;
                }
            }
        }
    }

    .special-services {
        padding: 67px 241px;
        background-image: url("../../assets/bg/diqvzhuyebanner2.png");
        /* background-size: cover; */
        background-position: center;
        background-repeat: no-repeat;

        .custom-row {
            display: flex;
            align-items: stretch;
        }

        .service-card {
            background: white;
            border-radius: 8px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            height: 100%;
            transition: all 0.3s ease;

            &:hover {
                /* transform: translateY(-5px); */
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
            }

            .service-image {
                height: 228px;
                overflow: hidden;
                /* border-radius: 8px 8px 0 0; */

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .service-content {
                padding: 40px 20px 10px 35px;
                min-height: 142px;
                box-sizing: border-box;

                h3 {
                    margin: 0 0 10px;
                    font-size: 20px;
                    text-align: center;
                    color: #333;
                    font-weight: normal;
                }

                p {
                    font-size: 14px;
                    color: #858585;
                    margin: 0;
                    line-height: 1.5;
                }
            }
        }
    }

    .core-resources {
        padding: 67px 241px;
        .custom-row {
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
            .el-col {
                margin-bottom: 20px;
            }
        }
        .resource-card {
            background: white;
            /* border-radius: 8px; */
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            overflow: hidden;
            height: 100%;

            .resource-image {
                height: 300px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .resource-content {
                padding: 30px;

                h3 {
                    margin: 0 0 10px;
                    font-size: 20px;
                    color: #333;
                }

                p {
                    font-size: 14px;
                    margin: 0;
                    color: #858585;
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .local-detail {
        .container {
            width: 100%;
            padding: 40px 20px;
        }
    }
}
</style>
